module.exports = __webpack_public_path__ + "media/brands/visa-7b9d9b2c.png";